import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { Modal, Divider, numberToCurrency } from 'vqp-common';
import { ClientDetailOrdersTable } from './'
import formatCpf from '../../utils/formatCpf'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 28px;
`

const Title = styled.span`
    font-size: 18px;
    color: ${props => props.theme.colors.textBold};
    margin-bottom: 27px;
    font-weight: 700;
`

const DetailsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
`

const Cell = styled.div`
    display: flex;
    flex-direction: column;
`

const Label = styled.span`
    font-size: 15px;
    color: ${props => props.theme.colors.textBold};
    font-weight: 700;
`

const Value = styled.span`
    font-size: 12px;
    color: ${props => props.theme.colors.textPrimary};
    margin-bottom: 13px;
`

export const ClientDetailModal = ({client, isOpen, onClose}) => {

    if (!client) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} boxWidth={"800px"}>
            <Wrapper>
                <Title>Detalhes do cliente</Title>
                <DetailsGrid>
                    <Cell>
                        <Label>Nome do cliente</Label>
                        <Value>{client.name}</Value>
                    </Cell>
                    <Cell>
                        <Label>CPF</Label>
                        <Value>{formatCpf(client.cpf)}</Value>
                    </Cell>
                    <Cell>
                        <Label>Último pedido</Label>
                        <Value>
                            {!client.lastOrder || !moment(client.lastOrder).isValid() || moment(client.lastOrder).year() < 1900
                                ? 'Nenhum pedido'
                                : moment(client.lastOrder).format('DD/MM/YYYY')}
                        </Value>
                    </Cell>
                    <Cell>
                        <Label>Email</Label>
                        <Value>{client.email}</Value>
                    </Cell>
                    <Cell>
                        <Label>Telefone</Label>
                        <Value>{client.phone}</Value>
                    </Cell>
                    <Cell>
                        <Label>Total dos pedidos</Label>
                        <Value>{numberToCurrency(client.ordersValue)}</Value>
                    </Cell>
                </DetailsGrid>
                <Divider marginV={"10px"} />
                <ClientDetailOrdersTable clientId={client.id} />
            </Wrapper>
        </Modal>
    )
}